import { __extends } from "tslib";
var ContactDetailInput = /*@__PURE__*/ (function () {
    function ContactDetailInput(_a) {
        var _b = _a.inputValue, inputValue = _b === void 0 ? "" : _b, _c = _a.minLength, minLength = _c === void 0 ? 1 : _c, _d = _a.maxLength, maxLength = _d === void 0 ? 30 : _d, errorMsg = _a.errorMsg, trackingErrorMsg = _a.trackingErrorMsg, label = _a.label, _e = _a.placeholder, placeholder = _e === void 0 ? "" : _e, valType = _a.valType;
        this.label = label;
        this.placeholder = placeholder;
        this.hasError = false;
        this.minLength = minLength;
        this.maxLength = maxLength;
        this.inputValue = inputValue;
        this.errorMsg = errorMsg;
        this.trackingErrorMsg = trackingErrorMsg;
        this.valType = valType;
    }
    ContactDetailInput.prototype.getLabel = function () {
        return this.label;
    };
    ContactDetailInput.prototype.getMinLength = function () {
        return this.minLength;
    };
    ContactDetailInput.prototype.getMaxLength = function () {
        return this.maxLength;
    };
    ContactDetailInput.prototype.getErrorMsg = function () {
        return this.errorMsg;
    };
    ContactDetailInput.prototype.getTrackingErrorMsg = function () {
        return this.trackingErrorMsg;
    };
    ContactDetailInput.prototype.getPlaceholder = function () {
        return this.placeholder;
    };
    ContactDetailInput.prototype.getValType = function () {
        return this.valType;
    };
    return ContactDetailInput;
}());
export { ContactDetailInput };
var ContactDetailRadio = /*@__PURE__*/ (function (_super) {
    __extends(ContactDetailRadio, _super);
    function ContactDetailRadio(_a) {
        var options = _a.options, _b = _a.minLength, minLength = _b === void 0 ? 1 : _b, _c = _a.maxLength, maxLength = _c === void 0 ? 30 : _c, errorMsg = _a.errorMsg, trackingErrorMsg = _a.trackingErrorMsg, label = _a.label, _d = _a.placeholder, placeholder = _d === void 0 ? "" : _d, _e = _a.inputValue, inputValue = _e === void 0 ? "" : _e, valType = _a.valType;
        var _this = _super.call(this, {
            minLength: minLength,
            maxLength: maxLength,
            errorMsg: errorMsg,
            trackingErrorMsg: trackingErrorMsg,
            label: label,
            placeholder: placeholder,
            inputValue: inputValue,
            valType: valType,
        }) || this;
        _this.options = [];
        _this.options = options;
        return _this;
    }
    ContactDetailRadio.prototype.getOptions = function () {
        return this.options;
    };
    return ContactDetailRadio;
}(ContactDetailInput));
export { ContactDetailRadio };
var Option = /*@__PURE__*/ (function () {
    function Option(_a) {
        var optionValue = _a.optionValue, _b = _a.optionLabel, optionLabel = _b === void 0 ? "" : _b;
        this.optionValue = optionValue;
        this.optionLabel = optionLabel === "" ? optionValue : optionLabel;
    }
    Option.prototype.getValue = function () {
        return this.optionValue;
    };
    Option.prototype.getLabel = function () {
        return this.optionLabel;
    };
    return Option;
}());
export { Option };
export var ValType;
(function (ValType) {
    ValType["STRING"] = "STRING";
    ValType["STRING_NUMERIC"] = "STRING_NUMERIC";
    ValType["STRING_NUMERIC_ONLY"] = "STRING_NUMERIC_ONLY";
    ValType["ALPHA_NUMERIC"] = "ALPHA_NUMERIC";
    ValType["EMAIL"] = "EMAIL";
    ValType["NUMERIC"] = "NUMERIC";
})(ValType || (ValType = {}));
/**
 * Contact Details Inputfields
 */
export var companyNameObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie einen gültigen Firmennamen ein",
    trackingErrorMsg: "Contact Details: Invalid company",
    label: "Firmenname",
    placeholder: "Firmenname",
    maxLength: 50,
    valType: ValType.STRING_NUMERIC,
});
export var titleObj = new ContactDetailRadio({
    errorMsg: "Bitte wählen Sie eine Anrede aus",
    trackingErrorMsg: "Contact Details: Invalid title",
    placeholder: "Bitte wählen Sie aus",
    label: "Anrede",
    inputValue: undefined,
    minLength: 3,
    maxLength: 5,
    valType: ValType.STRING,
    options: [
        new Option({ optionValue: "Frau" }),
        new Option({ optionValue: "Herr" }),
    ],
});
export var firstNameObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie einen gültigen Vornamen ein",
    trackingErrorMsg: "Contact Details: Invalid first name",
    label: "Vorname",
    placeholder: "Vorname",
    valType: ValType.STRING,
});
export var lastNameObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie einen gültigen Nachnamen ein",
    trackingErrorMsg: "Contact Details: Invalid last name",
    label: "Nachname",
    placeholder: "Nachname",
    valType: ValType.STRING,
});
export var companyRegistrationEntryObj = new ContactDetailRadio({
    errorMsg: "Bitte wählen Sie die für Ihr Unternehmen zutreffende Art des Eintrags aus",
    trackingErrorMsg: "Contact Details: Invalid company entry",
    label: "Handelsregister Eintrag",
    valType: ValType.STRING,
    options: [
        new Option({ optionValue: "HR A" }),
        new Option({ optionValue: "HR B" }),
        new Option({
            optionValue: "Ja",
            optionLabel: "Partnerschaftsregister",
        }),
        new Option({
            optionValue: "GR",
            optionLabel: "Genossenschaftsregister",
        }),
        new Option({ optionValue: "VR", optionLabel: "Vereinsregister" }),
    ],
});
export var registrationNumberObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie die Nummer Ihres Registereintrages ein",
    trackingErrorMsg: "Contact Details: Invalid registration number",
    label: "Details zum Registereintrag",
    placeholder: "Nummer",
    valType: ValType.NUMERIC,
});
export var companyLegalLocationObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie den Sitz des Amtsgerichts ein",
    trackingErrorMsg: "Contact Details: Invalid company legal location",
    label: "Details zum Registereintrag",
    placeholder: "Sitz des Amtsgerichtes",
    valType: ValType.STRING_NUMERIC,
});
export var streetObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie eine gültige Straße ein",
    trackingErrorMsg: "Contact Details: Invalid street",
    label: "Straße, Hausnummer",
    placeholder: "Straße",
    valType: ValType.STRING_NUMERIC,
});
export var streetNumberObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie eine gültige Hausnummer ein",
    trackingErrorMsg: "Contact Details: Invalid street number",
    label: "Straße, Hausnummer",
    placeholder: "Hausnummer",
    valType: ValType.STRING_NUMERIC,
});
export var zipCodeObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie eine gültige PLZ ein",
    trackingErrorMsg: "Contact Details: Invalid street number",
    label: "PLZ, Ort",
    minLength: 5,
    maxLength: 5,
    placeholder: "PLZ",
    valType: ValType.NUMERIC,
});
export var cityObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie einen gültigen Ort ein",
    trackingErrorMsg: "Contact Details: Invalid street number",
    label: "PLZ, Ort (Firma)",
    placeholder: "Ort",
    valType: ValType.STRING,
});
export var phonePrefixObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie eine gültige Vorwahl ein",
    trackingErrorMsg: "Contact Details: Invalid phone prefix",
    label: "Vorwahl, Rufnummer",
    minLength: 3,
    maxLength: 7,
    placeholder: "Vorwahl",
    valType: ValType.NUMERIC,
});
export var phoneNumberObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie eine gültige Rufnummer ein",
    trackingErrorMsg: "Contact Details: Invalid phone number",
    label: "Vorwahl, Rufnummer",
    minLength: 3,
    maxLength: 10,
    placeholder: "Rufnummer",
    valType: ValType.NUMERIC,
});
export var emailObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    trackingErrorMsg: "Contact Details: Invalid phone number",
    label: "E-Mail-Adresse",
    minLength: 6,
    maxLength: 80,
    placeholder: "E-Mail-Adresse",
    valType: ValType.EMAIL,
});
export var passwordObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie gültiges Kundenkennwort ein",
    trackingErrorMsg: "Contact Details: Invalid password",
    label: "Kundenkennwort",
    minLength: 6,
    maxLength: 10,
    placeholder: "Bitte ein Kundenkennwort eingeben",
    valType: ValType.STRING_NUMERIC_ONLY,
});
export var fixednetCustomerNumberObj = new ContactDetailInput({
    errorMsg: "",
    trackingErrorMsg: "",
    label: "Festnetz-Kundennummer",
    minLength: 0,
    maxLength: 50,
    placeholder: "Festnetz-Kundennummer",
    valType: ValType.STRING_NUMERIC,
});
export var companyRegistrationObj = new ContactDetailRadio({
    errorMsg: "",
    trackingErrorMsg: "",
    label: "",
    valType: "",
    options: [
        new Option({
            optionValue: "registered",
            optionLabel: "Ihre Firma ist im Handelsregister eingetragen",
        }),
        new Option({
            optionValue: "not_registered",
            optionLabel: "Selbstständiger/ Freiberufler mit Gewerbeanmeldung",
        }),
    ],
});
export var divergentBillingAddressObj = new ContactDetailRadio({
    errorMsg: "",
    trackingErrorMsg: "",
    label: "",
    valType: "",
    options: [
        new Option({
            optionValue: "no",
            optionLabel: "Keine abweichende Rechnungsadresse hinterlegen",
        }),
        new Option({
            optionValue: "yes",
            optionLabel: "Abweichende Rechnungsadresse hinterlegen",
        }),
    ],
});
// DIFFERING FIELDS FOR BUSINESS LICENCE
export var divergentBillingAddressNameObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie einen gültigen Namen/Firmennamen ein",
    trackingErrorMsg: "Contact Details: Invalid company",
    label: "Name / Firmenname",
    placeholder: "Name / Firmenname",
    maxLength: 50,
    valType: ValType.STRING_NUMERIC,
});
export var divergentBillingAddressStreetObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie eine gültige Straße ein",
    trackingErrorMsg: "Contact Details: Invalid street",
    label: "Straße, Hausnummer (Firma)",
    placeholder: "Straße",
    valType: ValType.STRING_NUMERIC,
});
export var divergentBillingAddressStreetNumberObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie eine gültige Hausnummer ein",
    trackingErrorMsg: "Contact Details: Invalid street number",
    label: "Straße, Hausnummer (Firma)",
    placeholder: "Hausnummer",
    valType: ValType.STRING_NUMERIC,
});
export var divergentBillingAddressZipCodeObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie eine gültige PLZ ein",
    trackingErrorMsg: "Contact Details: Invalid street number",
    label: "PLZ, Ort (Firma)",
    minLength: 5,
    maxLength: 5,
    placeholder: "PLZ",
    valType: ValType.NUMERIC,
});
export var divergentBillingAddressCityObj = new ContactDetailInput({
    errorMsg: "Bitte geben Sie einen gültigen Ort ein",
    trackingErrorMsg: "Contact Details: Invalid street number",
    label: "PLZ, Ort (Firma)",
    placeholder: "Ort",
    valType: ValType.STRING,
});



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-form/contact-details/contact-details-inputfields.ts
// module id = null
// module chunks = 